/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import { FormProvider } from "cms/forms/context/form.provider";
import { noop } from "lodash";
import { useState } from "react";
import ExistingFormsDialog from "sections/forms/dialogs/existing-forms-dialog";
import Message from "./message";

const FormsComponentEditor = () => {
    
    const { component, updateFactory } = useUpdateComponent();
    const form_id = component?.form_id;
    const questionsLength = component?.questionsLength;
    
    // eslint-disable-next-line no-unused-vars
    const [existingFormDialogOpen, setExistingFormsDialogOpen] = useState(false);
    
    const onChangeSelectedForm = updateFactory("form_id");
    
    return (
        <div className='simplicity-editor-frame'>
            <FormProvider>
                <Message
                    form_id={form_id}
                    questionsLength={questionsLength}
                    setExistingFormsDialogOpen={setExistingFormsDialogOpen}
                />
                {/* Hidden the Create Form and maybe re-use again the future */}
                {/* <CreateFormDialog
                    createDialogOpen={createDialogOpen}
                    setCreateDialogOpen={setCreateDialogOpen}
                    setExistingFormsDialogOpen={setExistingFormsDialogOpen}
                    setCreateFormFlowDialogOpen={setCreateFormFlowDialogOpen}
                    modal='composer'
                /> */}
                <ExistingFormsDialog
                    form_id={form_id}
                    onChangeSelectedForm={onChangeSelectedForm}
                    open={existingFormDialogOpen}
                    setOpen={setExistingFormsDialogOpen}
                    setCreateFormFlowDialogOpen={noop}
                    modal='composer'
                />
                {/* {form_id &&
                    <CreateFlow
                        formGuid={form_id}
                        createFormFlowDialogOpen={createFormFlowDialogOpen}
                        setCreateFormFlowDialogOpen={setCreateFormFlowDialogOpen}
                    />
                } */}
            </FormProvider>
            {/*{Config.Debug.useDebug && (*/}
            {/*    <div>*/}
            {/*        <details>*/}
            {/*            <summary>LocalState</summary>*/}
            {/*            <pre style={{fontSize: '9px', width: '800px', overflowX: 'auto', backgroundColor: '#efefef'}}>*/}
            {/*                {JSON.stringify(localState, null, 2)}*/}
            {/*            </pre>*/}
            {/*        </details>*/}
            {/*    </div>*/}
            {/*)}*/}
        </div>
    );
};
FormsComponentEditor.displayName = "FormsComponentEditor";
export { FormsComponentEditor };
